document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".fbt-section");
  if (!section) return;

  const checkboxes = section.querySelectorAll(".fbt-product-checkbox");
  const selects = section.querySelectorAll(".fbt-variant-select");
  const totalElement = section.querySelector(".fbt-total-value");
  const discountInfo = section.querySelector(".fbt-discount-info");
  const errorMessage = section.querySelector(".fbt-error-message");
  const addButton = section.querySelector(".fbt-add-btn");

  // --- Update total dynamically with offers ---
  function updateTotal() {
    let total = 0;

    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        const productCard = checkbox.closest(".fbt-product-card");
        const priceEl = productCard.querySelector(
          ".fbt-sale-price, .fbt-product-price span:not(.fbt-compare-price)"
        );
        if (priceEl) {
          const priceText = priceEl.textContent.replace(/[₹,]/g, "").trim();
          total += parseFloat(priceText);
        }
      }
    });

    let discount = 0;
    let discountText = "";

    if (total >= 11999) {
      discount = total * 0.2;
      discountText = "20% OFF applied (above ₹11,999)";
    } else if (total >= 7999) {
      discount = total * 0.1;
      discountText = "10% OFF applied (above ₹7,999)";
    }

    const discountedTotal = total - discount;

    totalElement.innerHTML = `
        <span style="text-decoration:${
          discount > 0 ? "line-through" : "none"
        };">
          ₹${total.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
        </span>
        ${
          discount > 0
            ? `<span style="color:#d32f2f; margin-left:8px;">₹${discountedTotal.toLocaleString(
                "en-IN",
                {
                  minimumFractionDigits: 2,
                }
              )}</span>`
            : ""
        }
      `;

    discountInfo.textContent = discountText;
  }

  // Update total when checkbox or variant changes
  checkboxes.forEach((checkbox) =>
    checkbox.addEventListener("change", () => {
      updateTotal();
      // Clear error message when user selects/deselects items
      errorMessage.textContent = "";
      errorMessage.classList.remove("show");
    })
  );
  selects.forEach((select) => select.addEventListener("change", updateTotal));
  updateTotal();

  // --- Check stock availability ---
  async function checkStock() {
    errorMessage.textContent = "";
    errorMessage.classList.remove("show");

    const outOfStock = [];

    // Get current cart to check existing quantities
    let cartItems = [];
    try {
      const cartResponse = await fetch("/cart.js");
      const cartData = await cartResponse.json();
      cartItems = cartData.items;
      console.log("Current cart:", cartItems);
    } catch (error) {
      console.error("Error fetching cart:", error);
    }

    // Only check selected products
    checkboxes.forEach((checkbox) => {
      if (!checkbox.checked) return;

      const productCard = checkbox.closest(".fbt-product-card");
      const select = productCard.querySelector(".fbt-variant-select");
      const selectedOption = select.options[select.selectedIndex];
      const variantId = select.value;
      const isAvailable = selectedOption.getAttribute("data-available");
      const inventory = parseInt(selectedOption.getAttribute("data-inventory"));
      const productTitle =
        productCard.querySelector(".fbt-product-title").textContent;
      const variantTitle = selectedOption.getAttribute("data-title");

      // Check how many of this variant are already in cart
      const cartItem = cartItems.find((item) => item.id == variantId);
      const inCartQty = cartItem ? cartItem.quantity : 0;
      const availableQty = inventory - inCartQty;

      // Log for debugging
      console.log("Checking:", productTitle, variantTitle);
      console.log("- Total inventory:", inventory);
      console.log("- Already in cart:", inCartQty);
      console.log("- Available to add:", availableQty);

      // Check if variant is out of stock (no more available after cart quantity)
      if (availableQty <= 0 || isNaN(inventory) || inventory === null) {
        outOfStock.push(`${productTitle} (${variantTitle})`);
      }
    });

    console.log("Final out of stock array:", outOfStock);
    return outOfStock;
  }

  // --- Add to Cart without page reload ---
  addButton.addEventListener("click", async (e) => {
    e.preventDefault();

    console.log("Button clicked!");
    console.log("Error element:", errorMessage);

    // Get only selected products
    const selectedItems = [];
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        const productCard = checkbox.closest(".fbt-product-card");
        const select = productCard.querySelector(".fbt-variant-select");
        selectedItems.push(select);
      }
    });

    if (selectedItems.length === 0) {
      errorMessage.textContent = "⚠️ Please select at least one product";
      errorMessage.classList.add("show");
      return;
    }

    // Check stock before adding
    const outOfStock = await checkStock();

    console.log("Out of stock items:", outOfStock);

    if (outOfStock.length > 0) {
      errorMessage.textContent = `⚠️ Out of Stock: ${outOfStock.join(", ")}`;
      errorMessage.classList.add("show");
      console.log("Error message should be visible now");
      return;
    }

    const items = selectedItems.map((select) => ({
      id: select.value,
      quantity: 1,
    }));

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    })
      .then((response) => response.json())
      .then(() => {
        // ✅ Try to open existing cart drawer dynamically
        const cartDrawer = document.querySelector(
          "cart-drawer, #CartDrawer, .cart-drawer"
        );
        if (cartDrawer) {
          document.body.classList.add("drawer-open");
          if (
            typeof window.cartDrawer !== "undefined" &&
            typeof window.cartDrawer.open === "function"
          ) {
            window.cartDrawer.open();
          } else {
            const openDrawerBtn = document.querySelector(
              '[data-drawer-trigger="cart"], .js-cart-toggle, .header__cart'
            );
            if (openDrawerBtn) openDrawerBtn.click();
          }
        } else {
          console.warn(
            "Cart drawer not found. Please check your drawer selector."
          );
        }
      })
      .catch((error) => {
        console.error("Error adding items:", error);
        errorMessage.textContent =
          "❌ Error adding items to cart. Please try again.";
        errorMessage.classList.add("show");
      });
  });
});
